module.exports = __webpack_public_path__ + "img/icon3.bac21686.png";